<template lang="pug">
    .collapsing-checkbox-collection
        .header
            | Filters ({{ totalSelected }})
            a(@click='reset') {{ resetText }}

        checkbox-category(
            v-for='(category, catidx) in categoryData',
            :collectionId="collectionId",
            :key="catidx",
            :model="model",
            :checkboxes="category.checkboxes",
            :category="category.category",
            :supercategory="category.supercategory",
            :classes="category.classes",
            :rowsVisibleWhenCollapsed="category.rowsVisibleWhenCollapsed",
            :expanded="category.expanded",
            :categoryIdx="catidx",
        )
</template>

<script>
    import uuid from 'uuid';

    import $ from '@rover/globals/jquery';
    import eventBus from '@rover/globals/eventBus';

    import CheckboxCategory from './CheckboxCategory.vue';

    export default {
        components: { CheckboxCategory },
        props: {
            model: {
                type: Object,
                required: true,
            },
            categories: {
                type: Array,
                required: true,
            },
            resetText: {
                type: String,
                required: false,
                default: 'Reset all',
            },
        },
        data() {
            return {
                collectionId: uuid.v4(),
                categoryData: this.categories,
            };
        },
        computed: {
            totalSelected() {
                return this.categoryData.reduce((sum, category) => {
                    return sum + category.checkboxes.filter(cb => this.isSelected(cb)).length;
                }, 0);
            },
        },
        methods: {
            reset() {
                this.$children.forEach((child) => { child.reset(); });
            },
            isSelected(checkbox) {
                const modelValue = this.model[checkbox.attribute];
                if (checkbox.bindValueToList > -1) {
                    // checkbox is bound to a list - check for its value in that list
                    return modelValue.includes(checkbox.bindValueToList);
                }
                return !!modelValue;
            },
        },
        watch: {
            totalSelected() {
                eventBus.$emit('update:totalSelected', this.totalSelected);
            },
        },
        mounted() {
            const $popovers = $(this.$el).find('.js-search-advanced-filter-checkbox-popover');
            if ($popovers.length) $popovers.popover();
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../../css/utilities/mixins';

    .collapsing-checkbox-collection {
        @include responsive-spacing('padding', 2);
        color: $text-color;
        font-size: 14px;
    }
    .header {
        display: flex;
        justify-content: space-between;
        @include responsive-spacing('margin-top', 2);
    }
    .slideVertically-enter-active, .slideVertically-leave-active {
        transition: all 0.25s;
    }
    .slideVertically-enter, .slideVertically-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// index.vue?52cfc574